<template>
	<dl class="ondotaiInfo sort-item" v-if="ptInitData.dispOndotaiFlg == 1">
		<dt :class="'ondotaiTitle ondotaiKbn_' + ptInitData.productInfo.ONDO_KBN">{{ $t('pt125.labels.temperatureZone') }}
		</dt>
		<dd :class="'ondotaiValue ondotaiKbn_' + ptInitData.productInfo.ONDO_KBN">{{ ptInitData.productInfo.ONDO_NM }}</dd>
	</dl>
</template>
<script>

	export default {
		name: 'OndotaiInfo',
		props: {
			ptInitData: {
				type: Object,
				default: null
			}
		},
	}
</script>